<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<header class="header">
  <div class="header__left">
    <div class="left__container">
      <a [routerLink]="['/']" class="container__logo">
        <img src="assets/logo.png" class="logo__img" />
      </a>
    </div>
    <nav mat-tab-nav-bar>
      <a
        mat-tab-link
        [matMenuTriggerFor]="tenantsMenu"
        [active]="
          list.isActive ||
          calcs.isActive ||
          metrics.isActive ||
          reports.isActive ||
          config.isActive ||
          configDiff.isActive ||
          convert.isActive
        "
      >
        <mat-icon class="header__icon">group</mat-icon>
        Tenants
        <mat-icon>arrow_drop_down</mat-icon>
      </a>
      <a
        mat-tab-link
        [routerLink]="'/data'"
        routerLinkActive
        #data="routerLinkActive"
        [active]="data.isActive"
      >
        <mat-icon class="header__icon">folder</mat-icon>
        Static Data
      </a>
    </nav>
  </div>

  <mat-menu #tenantsMenu="matMenu">
    <a mat-menu-item [routerLink]="'/tenants'" routerLinkActive #list="routerLinkActive">
      <mat-icon>group</mat-icon>
      List
    </a>
    <a mat-menu-item [routerLink]="'/tenants/calcs'" routerLinkActive #calcs="routerLinkActive">
      <mat-icon>list_alt</mat-icon>
      Calcs
    </a>
    <a mat-menu-item [routerLink]="'/tenants/metrics'" routerLinkActive #metrics="routerLinkActive">
      <mat-icon>insights</mat-icon>
      Metrics
    </a>
    <a mat-menu-item [routerLink]="'/tenants/reports'" routerLinkActive #reports="routerLinkActive">
      <mat-icon>library_books</mat-icon>
      Reports
    </a>
    <a mat-menu-item [routerLink]="'/tenants/config'" routerLinkActive #config="routerLinkActive">
      <mat-icon>dns</mat-icon>
      Config (cross-tenant)
    </a>
    <a
      mat-menu-item
      [routerLink]="'/tenants/config/compare'"
      routerLinkActive
      #configDiff="routerLinkActive"
    >
      <mat-icon>compare_arrows</mat-icon>
      Config comparison
    </a>
    <a
      mat-menu-item
      [routerLink]="'/tenants/portfolio-conversion'"
      routerLinkActive
      #convert="routerLinkActive"
    >
      <mat-icon>transform</mat-icon>
      Convert Portfolio
    </a>
    <a
      mat-menu-item
      [routerLink]="'/tenants/ini-script'"
      routerLinkActive
      #convert="routerLinkActive"
    >
      <mat-icon>terminal</mat-icon>
      INI Script
    </a>
  </mat-menu>

  <div class="header__right">
    @if (!(userDetailsLoading$ | async)) {
    <div class="account">
      <img class="account__image" [src]="(userDetails$ | async)?.picture" />
      <span class="account__name">{{ (userDetails$ | async)?.name }}</span>
    </div>
    }

    <mat-divider class="divider" [vertical]="true"></mat-divider>

    <button class="login" mat-button [matMenuTriggerFor]="environmentLoginMenu">
      Login to Environment
    </button>
    <mat-menu #environmentLoginMenu="matMenu">
      @if (userDetails$ | async; as userDetails) {
      <og-environment-login
        [userDetails]="userDetails"
        [allTenantsLoadable]="tenantDetails$ | async"
        [previewEnvironmentsLoadable]="previewEnvironments$ | async"
        (onLoginClicked)="loginToEnvironment($event)"
      ></og-environment-login>
      }
    </mat-menu>

    <mat-divider class="divider" [vertical]="true"></mat-divider>

    <button mat-icon-button matTooltip="Log out" (click)="logout()">
      <i class="material-icons">exit_to_app</i>
    </button>
  </div>
</header>
